import { Fragment, useState } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './RequestTableRow.utils'

import * as styles from './RequestTableRow.module.css'

function RequestTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  activeItem,
  availableSections,
  columns,
  context,
  emptyColumnSize,
  extra,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  statuses,
  onChangeVisibility,
  onClickDocFlowTag,
  onClickEmailTag,
  onClickFileTag,
  onClickRequestTag,
  ...restProps
}) {
  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const [isLoading, setLoading] = useState(false)

  const { id } = item

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.RequestTableRow,
    isActive: focusedRow === id || activeItem === id,
    isSelected,
  })

  function handleChangeVisibility(data) {
    setLoading(true)

    return onChangeVisibility?.(id, data).finally(() => {
      setLoading(false)
    })
  }

  return (
    <div
      {...qaProps}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            availableSections,
            context,
            extra,
            isActive: column.name === resizingColumn,
            isLoading,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            statuses,
            width: column.width,
            onChangeVisibility: handleChangeVisibility,
            onClickDocFlowTag,
            onClickEmailTag,
            onClickFileTag,
            onClickRequestTag,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default RequestTableRow
